var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.119,
    y1: 0.881,
    x2: 0.83,
    y2: 0.17,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#fedb16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#fec125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#fe983d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#fe5f5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fe2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000dc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(-31 -31)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(31 31)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27414",
    "data-name": "Group 27414",
    transform: "translate(40.772 40.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M147.959,131h-9.322a7.541,7.541,0,0,0-7.536,7.536v9.323a7.541,7.541,0,0,0,7.536,7.536h9.322a7.541,7.541,0,0,0,7.536-7.536v-9.323A7.541,7.541,0,0,0,147.959,131Zm4.813,16.868a4.826,4.826,0,0,1-4.822,4.822h-9.323a4.826,4.826,0,0,1-4.822-4.822v-9.323a4.826,4.826,0,0,1,4.822-4.822h9.323a4.826,4.826,0,0,1,4.822,4.822Z",
    transform: "translate(-131.1 -131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M198.338,192.1a6.238,6.238,0,1,0,6.238,6.238A6.249,6.249,0,0,0,198.338,192.1Zm0,10.025a3.788,3.788,0,1,1,3.788-3.788A3.791,3.791,0,0,1,198.338,202.125Z",
    transform: "translate(-186.145 -186.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 1.054,
    cy: 1.054,
    r: 1.054,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 17.527, 4.736)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f5b08021e56e684569d564125d9857af.svg";
export { ForwardRef as ReactComponent };